/*
 * Rooana: бързо добавяне в количката без напускане на страницата.
 * Използва се от:
 *   - snippets/rooana-pdp-addons.liquid  (ъпсел „Допълни с“ на продуктовата страница)
 *   - snippets/rooana-cart-addons.liquid (ъпсел „Добави и това“ в количката)
 *   - sections/rooana-product-set.liquid (комплекти – добавя всички продукти наведнъж)
 */
(function () {
  /* Форматира цена по формата на магазина (shop.money_format, подаден от Liquid). */
  function formatMoney(cents) {
    var format = window.rooanaMoneyFormat || '{{amount_with_comma_separator}} €';
    var value = ((Number(cents) || 0) / 100).toFixed(2);
    var parts = value.split('.');
    function group(sep) {
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    }
    var map = {
      amount: group(',') + '.' + parts[1],
      amount_no_decimals: group(','),
      amount_with_comma_separator: group('.') + ',' + parts[1],
      amount_no_decimals_with_comma_separator: group('.'),
      amount_with_space_separator: group(' ') + ',' + parts[1],
      amount_with_apostrophe_separator: group("'") + '.' + parts[1],
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      return map[key] !== undefined ? map[key] : map.amount;
    });
  }

  function updateBubble(sections) {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble || !sections || !sections['cart-icon-bubble']) return;
    var html = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
    var inner = html.querySelector('.shopify-section');
    if (inner) bubble.innerHTML = inner.innerHTML;
  }

  /* opts.openDrawer: след добавяне отваря cart drawer-а (комплекти), както при единичен продукт. */
  function addItems(items, opts) {
    var drawer = opts && opts.openDrawer ? document.querySelector('cart-drawer') : null;
    var sections = drawer ? 'cart-drawer,cart-icon-bubble' : 'cart-icon-bubble';
    return fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: sections, sections_url: window.location.pathname }),
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok || data.status) throw new Error(data.description || data.message || 'add-failed');
          return data;
        });
      })
      .then(function (data) {
        if (drawer && data.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents({ id: null, sections: data.sections });
        } else {
          updateBubble(data.sections);
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'rooana-addons' });
        }
        return data;
      });
  }

  function variantIdFor(row) {
    var select = row.querySelector('select[data-rooana-variant]');
    if (select) return Number(select.value);
    return Number(row.dataset.variantId);
  }

  /* ---------- Единичен ъпсел (PDP / количка) ---------- */
  if (!customElements.get('rooana-addons')) {
    customElements.define(
      'rooana-addons',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.init) return;
          this.dataset.init = 'true';
          this.errorEl = this.querySelector('[data-rooana-error]');

          this.addEventListener('change', function (evt) {
            var select = evt.target.closest('select[data-rooana-variant]');
            if (!select) return;
            var row = select.closest('[data-rooana-row]');
            var opt = select.options[select.selectedIndex];
            var priceEl = row && row.querySelector('[data-rooana-price]');
            if (priceEl && opt) priceEl.textContent = formatMoney(opt.dataset.price);
            var btn = row && row.querySelector('[data-rooana-add]');
            if (btn && btn.classList.contains('is-added')) {
              btn.classList.remove('is-added');
              btn.disabled = false;
              btn.textContent = btn.dataset.label;
            }
          });

          this.addEventListener('click', (evt) => {
            var button = evt.target.closest('[data-rooana-add]');
            if (!button || button.disabled) return;
            var row = button.closest('[data-rooana-row]');
            this.add(button, row);
          });
        }

        add(button, row) {
          var self = this;
          button.disabled = true;
          button.classList.add('loading');
          if (this.errorEl) this.errorEl.hidden = true;
          addItems([{ id: variantIdFor(row), quantity: 1 }])
            .then(function () {
              if (self.dataset.reload === 'true') {
                window.location.reload();
                return;
              }
              button.classList.remove('loading');
              button.classList.add('is-added');
              button.textContent = 'Добавено';
            })
            .catch(function (err) {
              button.disabled = false;
              button.classList.remove('loading');
              if (self.errorEl) self.errorEl.hidden = false;
              console.error('[rooana-addons]', err);
            });
        }
      }
    );
  }

  /* ---------- Комплект ---------- */
  if (!customElements.get('rooana-product-set')) {
    customElements.define(
      'rooana-product-set',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.init) return;
          this.dataset.init = 'true';
          this.button = this.querySelector('[data-set-add]');
          this.errorEl = this.querySelector('[data-rooana-error]');
          this.cartLink = this.querySelector('[data-set-cart]');
          this.addEventListener('change', (evt) => {
            if (!evt.target.closest('select[data-rooana-variant]')) return;
            var row = evt.target.closest('[data-rooana-row]');
            var opt = evt.target.options[evt.target.selectedIndex];
            var priceEl = row && row.querySelector('[data-rooana-price]');
            if (priceEl && opt) priceEl.textContent = formatMoney(opt.dataset.price);
            if (row && opt) row.dataset.price = opt.dataset.price;
            this.resetButton();
            this.recalc();
          });
          if (this.button) this.button.addEventListener('click', () => this.addAll());
          this.recalc();
        }

        rows() {
          return Array.from(this.querySelectorAll('[data-rooana-row]'));
        }

        /* Автоматичната отстъпка „-10% на всеки 2-ри продукт“ (BXGY) намалява
           по-евтиния артикул от всяка двойка. Изчислението тук е ориентировъчно –
           окончателната сума се показва в количката. */
        recalc() {
          var rows = this.rows();
          var prices = rows.map(function (r) {
            return Number(r.dataset.price) || 0;
          });
          var total = prices.reduce(function (a, b) {
            return a + b;
          }, 0);
          var saving = 0;
          if (this.dataset.promo === 'true') {
            var sorted = prices.slice().sort(function (a, b) {
              return a - b;
            });
            var discounted = Math.floor(prices.length / 2);
            for (var i = 0; i < discounted; i++) saving += Math.floor(sorted[i] * 0.1);
          }
          var totalEl = this.querySelector('[data-set-total]');
          var finalEl = this.querySelector('[data-set-final]');
          var savingEl = this.querySelector('[data-set-saving]');
          var savingWrap = this.querySelector('[data-set-saving-wrap]');
          if (finalEl) finalEl.textContent = formatMoney(total - saving);
          if (totalEl) {
            totalEl.textContent = saving > 0 ? formatMoney(total) : '';
            totalEl.hidden = saving <= 0;
          }
          if (savingEl) savingEl.textContent = formatMoney(saving);
          if (savingWrap) savingWrap.hidden = saving <= 0;
        }

        resetButton() {
          if (!this.button) return;
          this.button.disabled = false;
          this.button.classList.remove('is-added');
          this.button.textContent = this.button.dataset.label;
          if (this.cartLink) this.cartLink.hidden = true;
        }

        addAll() {
          var self = this;
          var items = this.rows().map(function (r) {
            return { id: variantIdFor(r), quantity: 1 };
          });
          this.button.disabled = true;
          this.button.classList.add('loading');
          if (this.errorEl) this.errorEl.hidden = true;
          addItems(items, { openDrawer: true })
            .then(function () {
              self.button.classList.remove('loading');
              self.button.classList.add('is-added');
              self.button.textContent = 'Добавено в количката';
              if (self.cartLink) self.cartLink.hidden = false;
            })
            .catch(function (err) {
              self.button.disabled = false;
              self.button.classList.remove('loading');
              if (self.errorEl) self.errorEl.hidden = false;
              console.error('[rooana-product-set]', err);
            });
        }
      }
    );
  }
})();
